import { CmStreamingFormat } from '@svta/cml-cta'

/**
 * Common Media Server Data Streaming Format
 *
 *
 * @enum
 *
 * @public
 */
export const CmsdStreamingFormat = CmStreamingFormat as typeof CmStreamingFormat

/**
 * @public
 */
export type CmsdStreamingFormat = CmStreamingFormat;
